import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import Monthly from './Monthly';
import Rollouts from './Rollouts';
import Modal from './Modal';
import { getModal } from './Modal/reducer';

const style = {
  calculator: {
    minWidth: 814,
  },
  calculatorModal: {
    minWidth: 814,
    filter: 'blur(3px)',
  },
};

const App = ({ classes, objectModal }) => {
  const openModal = objectModal.isVisible;
  const styleCalculator = openModal ? classes.calculatorModal : classes.calculator;

  return (
    <div>
      <Modal />
      <div className={styleCalculator}>
        <Monthly />
        <Rollouts />
      </div>
    </div>
  );
};

App.propTypes = {
  classes: PropTypes.object.isRequired,
  objectModal: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  objectModal: getModal(state),
});

export default connect(mapStateToProps)(injectSheet(style)(App));
